import React from "react";
import DesktopOnlyScreen from "../components/DesktopOnlyScreen";

function DeskTopView() {
  return <DesktopOnlyScreen />;
}

export default DeskTopView;
